'use client'
import { useRef } from 'react'
import Link from 'next/link'
import { dateToString } from 'utils/date'
import Button from './Button'
import { useMainContext } from 'utils/context'
import { torsCats } from 'config/const'
import { getResizedImg } from 'utils/media'
import { useDraggable } from 'react-use-draggable-scroll'

const CardsTorsHome = ({
  tors,
  title,
  theme,
  showCTA = false,
  showSpaces = true
}) => {
  const { setTorId } = useMainContext()
  const ref = useRef()
  const { events } = useDraggable(ref)

  return (
    <div className={theme == 'dark' ? 'bg-sec-grey-4' : 'bg-white'}>
      <div
        className={`mx-auto max-w-screen-2xl ${
          showSpaces ? 'py-12 px-4 sm:px-6 lg:px-8 lg:py-24' : ''
        }`}
      >
        <div className={`${showSpaces ? 'space-y-12' : ''}`}>
          <div className="flex">
            {/* <div className="grow"></div> */}
            <div className="relative overflow-hidden">
              <div className="flex flex-row items-center justify-between mb-10">
                <h2 className="text-[30px] lg:text-[40px] font-alliance-medium tracking-tight text-blue">
                  {title}
                </h2>
                {/* {showFilters ? (
                  <Button
                    text={
                      <>
                        <img
                          src="/assets/icons/filter.svg"
                          alt="filter"
                          className="mr-4 w-6 lg:w-8"
                        />
                        <p className="font-alliance-medium">Filtre</p>
                      </>
                    }
                    size="medium"
                    color={theme == 'dark' ? 'white' : 'sec-grey-4'}
                  />
                ) : null} */}
              </div>
              <div className="absolute hidden sm:block h-full z-10 right-0 w-4 from-sec-grey-4 bg-gradient-to-l" />
              <ul
                role="list"
                className="cards-home grid gap-0 sm:gap-4 lg:gap-6 overflow-hidden"
                {...events}
                ref={ref}
              >
                {tors.map((tor, idx) => {
                  let [torName, torPlace] = tor.Name.split(' - ')
                  torPlace = torPlace || ''
                  const date = `${dateToString(tor.StartDate).dayMin} - ${
                    dateToString(tor.EndDate).dayMin
                  }`
                  const endToRegister = dateToString(tor.MaximumDate)?.full
                    ? `Límit inscripció fins ${
                        dateToString(tor.MaximumDate)?.full
                      }`
                    : ''
                  const torInfo = torsCats.find(
                    ({ id }) => tor.CategoryFilter?.toLowerCase() === id
                  )
                  const link =
                    tor?.Link ||
                    `${torInfo.torUrl}/${tor.Year}/${tor.Slug}/informacio`
                  const poster = tor?.Poster
                    ? tor.Poster
                    : tor.Image1
                    ? getResizedImg(tor.Image1)
                    : `/assets/images/tors-posters/${
                        torInfo.poster || torInfo.keyword
                      }.webp`

                  return (
                    <li key={idx} className="mb-4 mt-2 lg:mt-12 max-w-[386px]">
                      {/* MOBILE VIEW */}
                      <div className="block sm:hidden">
                        {/* <div>
                          {tor.Name && (
                            <div className={`${bgColor}`}>
                              <div className="flex justify-center">
                                <p className="text-blue font-alliance-medium text-[12px] p-2">
                                  {tor.Name}
                                </p>
                              </div>
                            </div>
                          )}
                        </div> */}
                        <div className="flex bg-white">
                          <div className="group">
                            <Link
                              href={link}
                              onClick={async () => {
                                await setTorId(tor.id)
                              }}
                              target={tor?.Link ? '_blank' : '_parent'}
                            >
                              <div className="relative w-[138px] h-full">
                                <div
                                  className={`absolute w-full h-full transition ease-in-out bg-opacity-0 group-hover:bg-${torInfo.color} group-hover:bg-opacity-80 duration-300`}
                                >
                                  <div className="grid h-full place-items-center transition ease-in-out opacity-0 group-hover:opacity-100 duration-300">
                                    <div className="flex justify-center">
                                      <p className="text-[20px] font-alliance-medium text-blue">
                                        Ves-hi
                                      </p>
                                      <img
                                        src="/assets/icons/arrow-circle-right.svg"
                                        alt=""
                                        className="pointer-events-none object-fill w-6 ml-2"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="">
                                  <img
                                    className="object-cover w-[138px] h-full"
                                    src={poster}
                                    alt=""
                                  />
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div className="grid m-3 w-full">
                            <div key={tor.Campus} className="flex capitalize">
                              <div className="flex flex-1 flex-col justify-between">
                                <div className="flex-1 leading-tight">
                                  <p className="font-alliance-medium text-[24px] text-gray-900 capitalize">
                                    {torName.toLowerCase()}
                                  </p>
                                  <p className="font-alliance-light text-[24px] text-blue capitalize">
                                    {torPlace.toLowerCase()}
                                  </p>
                                </div>
                                <div className="flex justify-between mt-2 w-full">
                                  <div className="">
                                    <div className="flex-shrink-0">
                                      <span className="sr-only">
                                        {tor.datetime}
                                      </span>
                                    </div>
                                    <div className="">
                                      <p className="text-[14px] font-alliance-medium text-blue">
                                        {tor.torPlace}
                                      </p>
                                      <p className="flex space-x-1 text-[14px] font-alliance-medium text-blue">
                                        {date}
                                      </p>
                                      <p className="flex space-x-1 text-[14px] font-alliance-medium text-blue opacity-50">
                                        {tor?.Extra || endToRegister}
                                      </p>
                                    </div>
                                  </div>
                                  {showCTA ? (
                                    <div className="">
                                      <Link href="#">
                                        <img
                                          src={`/assets/icons/arrow-circle-right.svg`}
                                          alt="icon"
                                          className="w-8"
                                        />
                                      </Link>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* DESKTOP VIEW */}
                      <div className="hidden sm:block">
                        <div className="group">
                          <Link
                            href={link}
                            onClick={async () => {
                              await setTorId(tor.id)
                            }}
                            target={tor?.Link ? '_blank' : '_parent'}
                          >
                            <div className="relative h-full">
                              {/* <div className="relative w-[382px] h-full"> */}
                              <div
                                className={`absolute w-full h-full transition ease-in-out bg-opacity-0 group-hover:bg-${torInfo.color} group-hover:bg-opacity-80 duration-300`}
                              >
                                <div className="grid h-full place-items-center transition ease-in-out opacity-0 group-hover:opacity-100 duration-300">
                                  <div className="flex justify-center">
                                    <p className="text-[40px] font-alliance-medium text-blue">
                                      Ves-hi
                                    </p>
                                    <img
                                      src="/assets/icons/arrow-circle-right.svg"
                                      alt=""
                                      className="pointer-events-none object-fill w-12 ml-5"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="">
                                <img
                                  className="object-cover w-full h-full"
                                  src={poster}
                                  alt=""
                                />
                                {/* {tor.Name && (
                                    <div
                                      className={`absolute ${bgColor} bg-opacity-95 bottom-0`}
                                    >
                                      <div className="flex w-[382px]">
                                        <p className="text-blue font-alliance-semibold text-[20px] p-3">
                                          {tor.Name}
                                        </p>
                                      </div>
                                    </div>
                                  )} */}
                              </div>
                            </div>
                          </Link>
                        </div>
                        {showCTA ? (
                          <div className="mt-6">
                            {!tor.inscriptionClosed ? (
                              <Button
                                link={`/privat/federat/competicio/inscripcio/${tor.Slug}`}
                                text="INSCRIU-TE"
                                size="medium"
                              />
                            ) : (
                              <Button
                                link={null}
                                text="INSCRIPCIÓ TANCADA"
                                size="medium"
                                color="grey"
                              />
                            )}
                          </div>
                        ) : null}
                        <div key={tor.Campus} className="flex flex-col">
                          <div className="flex flex-1 flex-col justify-between">
                            <div className="flex-1 leading-tight min-h-[100px]">
                              <p className="mt-6 font-alliance-medium text-[30px] text-gray-900">
                                {torName}
                              </p>
                              <p className="font-alliance-light text-[30px] text-blue">
                                {torPlace}
                              </p>
                            </div>
                            <div className="flex items-center mt-6">
                              <div className="flex-shrink-0">
                                <span className="sr-only">{tor.datetime}</span>
                              </div>
                              <div className="">
                                <p className="text-[18px] font-alliance-medium text-blue">
                                  {tor.torPlace}
                                </p>
                                <p className="flex space-x-1 text-[18px] font-alliance-medium text-blue">
                                  {date}
                                </p>
                                <p className="flex space-x-1 text-[18px] font-alliance-medium text-blue opacity-50">
                                  {tor?.Extra || endToRegister}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardsTorsHome
